"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageTooltip = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _react = require("react");

var _Tooltip = require("../../atoms/Tooltip");

var _jsxRuntime = require("react/jsx-runtime");

var ImageTooltip = function ImageTooltip(props) {
  var className = props.className,
      sizeLoading = props.sizeLoading,
      colorLoading = props.colorLoading,
      classNameLoading = props.classNameLoading,
      src = props.src,
      componentDefault = props.componentDefault,
      classNameImg = props.classNameImg,
      classNameTooltip = props.classNameTooltip,
      componentTooltip = props.componentTooltip,
      position = props.position;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      imgLoad = _useState2[0],
      setImgLoad = _useState2[1];

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Tooltip.Tooltip, {
    position: position !== null && position !== void 0 ? position : "topCenter",
    addArrow: false,
    transitionType: "zoom",
    followCursor: false,
    className: className,
    classNameTooltip: classNameTooltip,
    componentTooltip: imgLoad !== undefined && componentTooltip,
    children: [src && imgLoad === undefined && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContainerLoading, {
      className: classNameLoading,
      sizeLoading: sizeLoading,
      colorLoading: colorLoading,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFontawesome.FontAwesomeIcon, {
        pulse: true,
        icon: _freeSolidSvgIcons.faSpinner
      })
    }), (!src || imgLoad === false) && componentDefault, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Img, {
      className: classNameImg,
      src: "".concat(src, "?").concat(new Date().getMilliseconds()),
      onLoad: function onLoad() {
        return setImgLoad(true);
      },
      onError: function onError() {
        return setImgLoad(false);
      },
      show: imgLoad === true
    })]
  });
};

exports.ImageTooltip = ImageTooltip;